// import Vue from 'vue'
import baseContextComponent from "@/components/baseContextComponent";
import { Component } from "vue-property-decorator";

@Component({})
export default class homePage extends baseContextComponent {
	title:string = "Benvenuto nello";
	subtitle:string = "Staging Managment";
}
